import React from "react";
import {
  Box,
  makeStyles,
  styled,
  Theme,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import { OilCoversFragment_covers } from "./__generated__/OilCoversFragment";
import OilCover, {
  getCoverMargin,
  getCoverWidthHeight,
  OilCoverSize
} from "./OilCover";

// Infinite scrolling css reference: https://codepen.io/nickcil/pen/BygPMY
const useStyles = makeStyles({
  "@global": {
    "@keyframes oilCoversSlideshow-left": {
      "0%": { transform: "translateX(0%)" },
      "100%": {
        transform: "translateX(-100%)"
      }
    },
    "@keyframes oilCoversSlideshow-right": {
      "0%": { transform: "translateX(-100%)" },
      "100%": {
        transform: "translateX(0%)"
      }
    }
  }
});

const AnimatedCovers = styled("div")({
  height: "100%",
  width: "200%",
  display: "flex"
  // "&:hover > *": {
  //   "animation-play-state": "paused" // Pause all animation groups on mouse hover
  // }
});

// We have two group, once the first group has reach completely to the left out of the viewport,
// it will come back to his original position to create a infinite animation
const AnimatedCoversGroup = styled("div")(
  ({
    theme,
    speed,
    direction
  }: {
    theme: Theme;
    speed: number;
    direction: "left" | "right";
  }) => ({
    display: "flex",
    alignItems: "center",
    willChange: "transform",
    animation: `oilCoversSlideshow-${direction} ${120 /
      speed}s linear infinite`,
    [theme.breakpoints.down("xs")]: {
      animation: `oilCoversSlideshow-${direction} ${30 /
        speed}s linear infinite`
    }
  })
);

export default function AnimatedOilCovers({
  covers,
  speed,
  direction,
  size
}: {
  covers: OilCoversFragment_covers[];
  speed?: number;
  direction?: "left" | "right";
  size?: OilCoverSize;
}) {
  useStyles();
  const theme = useTheme();

  // We need enough oil covers to fill a whole horizontal screen on xl desktop
  let longCoversList = [...covers];
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"), {
    defaultMatches: false
  });
  if (isLargeScreen) {
    longCoversList = [...covers, ...covers, ...covers];
  }

  const { xs } = getCoverWidthHeight(size);
  const margin = getCoverMargin(size);

  return (
    <Box
      overflow="hidden"
      position="relative"
      height={{ xs: xs, sm: "auto" }}
      mb={margin}
    >
      <AnimatedCovers>
        <AnimatedCoversGroup speed={speed} direction={direction}>
          {longCoversList.map((cover, i) => (
            <OilCover key={i} size={size} {...cover} />
          ))}
        </AnimatedCoversGroup>
        <AnimatedCoversGroup speed={speed} direction={direction}>
          {longCoversList.map((cover, i) => (
            <OilCover key={i} size={size} {...cover} />
          ))}
        </AnimatedCoversGroup>
      </AnimatedCovers>
    </Box>
  );
}
